class BlogFilter extends HTMLElement {
    constructor() {
        super();
        this.tabLinks = this.querySelectorAll('.custom-tab');
        this.contentContainer = document.querySelector('.blog-articles');
        this.paginationContainer = document.querySelector('infinite-scroll');
        this.init();
    }

    init() {
        this.tabLinks.forEach(link => {
            // Skip event listener for direct links
            if (!link.hasAttribute('data-direct-link')) {
                link.addEventListener('click', this.handleTabClick.bind(this));
            }
        });

        window.addEventListener('popstate', (event) => {
            if (event.state && event.state.url) {
                this.loadContent(event.state.url, false);
            }
        });
    }

    handleTabClick(event) {
        event.preventDefault();
        const url = event.currentTarget.getAttribute('href');
        this.tabLinks.forEach(link => link.classList.remove('custom-tab--active'));
        event.currentTarget.classList.add('custom-tab--active');
        this.loadContent(url, true);
    }

    async loadContent(url, updateHistory = true) {
        if (this.contentContainer) {
            this.contentContainer.style.opacity = '0.5';
            this.contentContainer.style.pointerEvents = 'none';
        }

        try {
            const response = await fetch(url);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('.blog-articles');
            const newPagination = doc.querySelector('infinite-scroll');
            const newTabs = doc.querySelectorAll('.custom-tab');

            if (this.contentContainer && newContent) {
                this.contentContainer.innerHTML = newContent.innerHTML;
                this.contentContainer.className = newContent.className;
            }

            if (this.paginationContainer && newPagination) {
                const currentPagination = this.paginationContainer.querySelector('.pagination-wrapper');
                const newPaginationWrapper = newPagination.querySelector('.pagination-wrapper');

                if (currentPagination && newPaginationWrapper) {
                    currentPagination.innerHTML = newPaginationWrapper.innerHTML;
                }
            }

            if (newTabs.length > 0) {
                this.tabLinks.forEach((link, index) => {
                    if (newTabs[index]) {
                        if (newTabs[index].classList.contains('custom-tab--active')) {
                            link.classList.add('custom-tab--active');
                        } else {
                            link.classList.remove('custom-tab--active');
                        }
                    }
                });
            }

            if (updateHistory) {
                window.history.pushState({ url: url }, '', url);
            }

            if (this.contentContainer) {
                this.contentContainer.style.opacity = '1';
                this.contentContainer.style.pointerEvents = 'auto';
            }

            if (window.Shopify && window.Shopify.PaymentButton) {
                window.Shopify.PaymentButton.init();
            }

        } catch (error) {
            console.error('Error loading blog content:', error);

            if (this.contentContainer) {
                this.contentContainer.style.opacity = '1';
                this.contentContainer.style.pointerEvents = 'auto';
            }

            window.location.href = url;
        }
    }
}

customElements.define('blog-filter', BlogFilter);
